import axios from 'axios';
import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { history as hashHistory } from '../../services';
import {
  AddToast,
  FindInitialRestaurant,
  SetBounced,
  SetRestaurantUrl
} from '../../actions/Actions';
import * as Api from '../../Api';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import { routerActions } from '../../redux';
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type StateProps = ReturnType<typeof mapStateToProps>;

interface State {
  Redirect: boolean;
  OpenPWA: boolean;
  vrid: number;
  FoundRestaurant: boolean;
  FoundRestaurantRedirect: boolean;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}, {}>;

class SetCookie extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    this.state = {
      Redirect: false,
      OpenPWA: false,
      vrid: 0,
      FoundRestaurant: false,
      FoundRestaurantRedirect: false
    };
  }

  public componentWillMount() {
    this.props.updateRouterState({
      pathname: this.props.location.pathname,
      params: this.props.params
    });
  }

  public componentDidMount() {
    Utilities.detectPrivateMode((is_private: any) => {
      const isPrivate =
        typeof is_private === 'undefined'
          ? 'cannot detect'
          : is_private
          ? 'private'
          : 'not private';
      if (isPrivate === 'private') {
        alert(this.props.translate('Private_browsing'));
      }
    });

    const { Bounced } = this.props;
    const isSafari =
      navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent;

    if (localStorage.getItem('flipdish-device-id') != null && !isSafari) {
      this.props.SetBounced(true);
    } else if (!Bounced) {
      console.log('app with hash', window.location.hash);
      const target =
        axios.defaults.baseURL +
        '/api/weborder/bounce?url=' +
        encodeURIComponent(window.location.href);
      console.log('redirecting to ', target);
      window.location.replace(target);
    }
  }

  public UNSAFE_componentWillReceiveProps(newProps: Props) {
    const {
      Bounced,
      location,
      AppConfig,
      CollectionSummaries,
      FindInitialRestaurant,
      ClientAnalytics
    } = newProps;

    if (this.props.location.pathname !== newProps.location.pathname) {
      this.props.updateRouterState({
        pathname: newProps.location.pathname,
        params: newProps.params
      });
    }

    const isPwa: boolean = Utilities.extraOption('data-pwa') == 'true';

    //Analytics PWA open
    if (!this.state.OpenPWA && ClientAnalytics && isPwa && Utilities.isStandalone) {
      //Track('PWA Open')
      this.setState({ OpenPWA: true });
    }

    //Redirect on '/'
    if (this.props.location.pathname != location.pathname && location.pathname === '/') {
      hashHistory.replace('/where');
    }

    if (newProps.Customer.status === 'success' && this.props.Customer.status != 'success') {
      this.props.AddToast(this.props.translate('Logged_in') as string);
    }

    if (
      Bounced &&
      AppConfig.status == 'success' &&
      !this.state.Redirect &&
      !Utilities.isStandalone
    ) {
      switch (AppConfig.data.WebToAppRedirect) {
        case Api.WebToAppRedirect.RedirectOnce:
          if (localStorage.getItem('flipdish-redirect') == 'true') {
            this.setState({ Redirect: true });

            const redirectConfirm = window.confirm(
              this.props.translate('Redirect_confirm') as string
            );

            if (redirectConfirm) {
              if (Utilities.isAndroid && AppConfig.data.PlayStoreUrl) {
                window.location.href = AppConfig.data.PlayStoreUrl;
                break;
              } else if (Utilities.isIOSPhone && AppConfig.data.AppStoreUrl) {
                window.location.href = AppConfig.data.AppStoreUrl;
                break;
              }
            }
          } else {
            if (Utilities.isAndroid && AppConfig.data.PlayStoreUrl) {
              this.setState({ Redirect: true });
              Utilities.setInLocalStorage('flipdish-redirect', 'true');
              window.location.href = AppConfig.data.PlayStoreUrl;
              break;
            } else if (
              Utilities.isIOSPhone &&
              !(window as any).MSStream &&
              AppConfig.data.AppStoreUrl
            ) {
              this.setState({ Redirect: true });
              Utilities.setInLocalStorage('flipdish-redirect', 'true');
              window.location.href = AppConfig.data.AppStoreUrl;
              break;
            }
          }
          break;

        case Api.WebToAppRedirect.RedirectAlways:
          if (Utilities.isAndroid && AppConfig.data.PlayStoreUrl) {
            this.setState({ Redirect: true });
            window.location.href = AppConfig.data.PlayStoreUrl;
            break;
          } else if (Utilities.isIOSPhone && AppConfig.data.AppStoreUrl) {
            this.setState({ Redirect: true });
            window.location.href = AppConfig.data.AppStoreUrl;
            break;
          }
          break;

        case Api.WebToAppRedirect.SuggestPwa:
          /*if (!isPwa && Utilities.flipdiv && (Android || iOSPhone)) {
            let message = '';

            if (Android) {
              message = this.props.translate('Pwa_android_prompt');
            } else if (iOSPhone) {
              message = this.props.translate('Pwa_ios_prompt');
            }

            (window as any).addToHomescreen({
              displayPace: 0,
              detectHomescreen: true,
              message,
              onAdd: () => {
                //Track('PWA Install')
              }
            });
          }*/
          break;

        case Api.WebToAppRedirect.ForcePwa:
          /*if (!isPwa && Utilities.flipdiv && (Android || iOSPhone)) {
            let message = '';

            if (Android) {
              message = this.props.translate('Pwa_android_prompt_fullscreen');
            } else if (iOSPhone) {
              message = this.props.translate('Pwa_ios_prompt_fullscreen');
            }

            (window as any).addToHomescreen({
              mandatory: true,
              startDelay: 0,
              displayPace: 0,
              lifespan: 0,
              fullScreen: true,
              message,
              detectHomescreen: true,
              fullScreenMessage: {
                get: this.props.translate('Get_the_app'),
                step_one: this.props.translate('Click_the_menu_icon'),
                step_two: this.props.translate('Add_to_home_screen'),
                boom: this.props.translate('Boom')
              },
              onAdd: () => {
                //Track('PWA Install')
              }
            });
          }*/
          break;
      }
    }

    //If already bounced and arrive at the / path redirect
    if (
      Bounced &&
      AppConfig.status == 'success' &&
      !this.state.FoundRestaurant &&
      ClientAnalytics != this.props.ClientAnalytics
    ) {
      FindInitialRestaurant((vrid: number) => {
        //Prevent further API calls
        this.setState({ FoundRestaurant: true });

        //Redirect if only on base path
        if (location.pathname === '/') {
          //If CollectionSummaries loaded do the redirect else store vrid in state and wait for CollectionSummaries to load
          if (CollectionSummaries.status == 'success') {
            this.FindRestaurant(vrid, newProps);
          } else {
            this.setState({ vrid }, () => {
              //If CollectionSummaries were loaded while the initial restaurant was being found
              this.FindRestaurant(vrid);
            });
          }
        }
      });
    }

    //Once CollectionSummaries has loaded use stored vrid for the redirect
    if (
      CollectionSummaries.status == 'success' &&
      CollectionSummaries != this.props.CollectionSummaries &&
      this.state.vrid != 0 &&
      !this.state.FoundRestaurantRedirect
    ) {
      this.FindRestaurant(this.state.vrid, newProps);
    }
  }

  public FindRestaurant = (vrid: number, newProps?: Props) => {
    this.setState({ FoundRestaurantRedirect: true });

    const { AppConfig, showRestaurantList } = newProps || this.props;

    const isPwa: boolean = Utilities.extraOption('data-pwa') == 'true';

    if (AppConfig.status == 'success') {
      const pwaOnMobile =
        (Utilities.isAndroid || Utilities.isIOSPhone) && Utilities.isStandalone && isPwa;

      const lastUrl = localStorage.getItem('flipdish-last-url');
      const lastUrlExpiry = localStorage.getItem('flipdish-last-url-expiry');

      if (lastUrl && lastUrlExpiry && Date.now() < parseInt(lastUrlExpiry) && pwaOnMobile) {
        hashHistory.replace(lastUrl.substr(1));
      } else if (
        !AppConfig.data.PickupEnabled &&
        AppConfig.data.DisplayDeliveryRestaurantListScreen
      ) {
        hashHistory.replace('/delivery');
      } else if (
        !AppConfig.data.DeliveryEnabled &&
        AppConfig.data.DisplayPickupRestaurantListScreen
      ) {
        hashHistory.replace(this.collectionLink());
      } else if (!showRestaurantList) {
        const url = '/restaurant/' + vrid;
        this.props.SetRestaurantUrl(url);
        hashHistory.replace(url);
      } else {
        hashHistory.replace('/where');
      }
    }
  };

  public collectionLink(): string {
    const { AppConfig, CollectionSummaries } = this.props;

    switch (AppConfig.status) {
      case 'success':
        break;
      default:
        return '/collection';
    }

    if (AppConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (CollectionSummaries.status != 'success') {
      return '/collection';
    }

    const [skip] = CollectionSummaries.data.filter((c) => c.SkipToThisPhysicalRestaurant);

    if (!skip) {
      return '/collection';
    }

    return '/restaurant/' + skip.VirtualRestaurantId + '/collection/' + skip.PhysicalRestaurantId;
  }

  public renderChildren() {
    const { children } = this.props;

    if (!children) {
      return;
    }

    return React.Children.map(children, (c) => {
      return React.cloneElement(c as any, {
        parentComponent: this
      });
    });
  }

  public render(): JSX.Element {
    const { Bounced, isDark, AppDesignScheme } = this.props;

    const styles = {
      root: {
        backgroundColor: AppDesignScheme.Primary
      },
      tertiaryBg: {
        backgroundColor: AppDesignScheme.Tertiary
      }
    };

    const isPwa: boolean = Utilities.extraOption('data-pwa') == 'true';

    if (!isPwa && Utilities.isStandalone) {
      return <LoadingPanel isDark={isDark} AppDesignScheme={AppDesignScheme} />;
    }

    if (!Bounced) {
      return <LoadingPanel isDark={isDark} AppDesignScheme={AppDesignScheme} />;
    } else {
      return <>{this.renderChildren()}</>;
    }
  }
}

const mapStateToProps = (s: Store.State) => {
  return {
    showRestaurantList: s.flipdish.Config.showRestaurantList,
    Bounced: s.flipdish.Bounced,
    isDark: s.flipdish.isDark,
    AppConfig: s.flipdish.AppConfig,
    CollectionSummaries: s.flipdish.CollectionSummaries,
    ClientAnalytics: s.flipdish.ClientAnalytics,
    Customer: s.flipdish.Customer,
    translate: getTranslate(s.locale),
    AppDesignScheme: s.appDesignScheme
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateRouterState: (payload: WebOrder.State.Location) => {
      dispatch(routerActions.updateRouterState(payload));
    },
    FindInitialRestaurant: (then: (vrid: number) => any): any => {
      dispatch(FindInitialRestaurant(then));
    },

    SetRestaurantUrl: (url: string) => {
      dispatch(SetRestaurantUrl(url));
    },

    SetBounced: (bounced: boolean) => {
      dispatch(SetBounced(bounced));
    },

    AddToast: (message: string) => {
      dispatch(AddToast(message));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetCookie);
